import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CollectionService } from '@services/collection.service';
import { RoleManagementService } from '@services/role.management.service';
import { UserService } from '@services/user.service';
import { Subscription } from 'rxjs';
import { RoleManagement } from '@configs/role.config';
import { WebErrorService } from '@services/webError.service';
import { IdleService } from 'src/app/shared/idle.service';
import { NotificationService } from '@services/notification.service';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordSComponent implements OnInit {
  changePassword: FormGroup;
  submitted: any;
  captchaData$: Subscription;
  CaptchaImgUrl: string = "";
  CaptchaTextValue: string = "";
  CaptchaTokenValue: string = "";
  isValid: boolean = false;
  isDisplayError: boolean = false;
  loginErrorMessage: any;
  userData: any;
  collectionData$: Subscription | undefined;
  validateCaptcha$: Subscription;
  changePasswordMessage: any;
  fullyear = new Date().getFullYear();
  constructor(public fb: FormBuilder,
    public userService: UserService,
    private router: Router,
    private roleSer: RoleManagementService,
    private collectionService: CollectionService,
    private webErrorService: WebErrorService,
    private notificationService: NotificationService,
    public idleService: IdleService,) {
      this.CaptchaImgUrl = '../../../assets/favicon/images.jfif';
      this.userData = JSON.parse(localStorage.getItem('userData'));
    }

  ngOnInit(): void {
    this.CaptchaImgUrl = '../../../assets/favicon/images.jfif';
    this.changePassword = new FormGroup({
      oldPassword: new FormControl('',
        [Validators.required]),
      newPassword: new FormControl('',
        [Validators.required,
        Validators.minLength(12),
        Validators.maxLength(20),
        // Validators.pattern(/^(?!.*(.)\1)(?!.*?123|321|234|432|345|543|456|654|567|765|678|876|789|987|890|098)(?=.{12,}).*$/),
        Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%&*^])[a-zA-Z0-9!@#$%&*^]{12,}$'),
        ]),
      confirmPassword: new FormControl('',
        [Validators.required,
        Validators.minLength(12),
        Validators.maxLength(20),
        // Validators.pattern(/^(?!.*(.)\1)(?!.*?123|321|234|432|345|543|456|654|567|765|678|876|789|987|890|098)(?=.{12,}).*$/),
        Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%&*^])[a-zA-Z0-9!@#$%&*^]{12,}$'),
        ]),
      captchaText: new FormControl('', [Validators.required])
    });

    this.getCaptcha();
  }

  get f() {
    return this.changePassword.controls;
  }

  getCaptcha(){
    if(this.captchaData$){this.captchaData$.unsubscribe();}
    this.captchaData$ = this.userService.getCaptcha().subscribe(data => {
      if(data) {
        this.CaptchaImgUrl = data.dntCaptchaImgUrl;
        this.CaptchaTokenValue = data.dntCaptchaTokenValue;
        this.CaptchaTextValue = data.dntCaptchaTextValue;
      }
    });
  }

  resendCaptcha() {
    this.getCaptcha();
  }

  submit() {
    let payloadForChange = {
      "id": this.userData.userID,
      "emailId": this.userData.email,
      "oldPassword": this.changePassword.value.oldPassword,
      "newPassword": this.changePassword.value.newPassword,
      "confirmPassword": this.changePassword.value.confirmPassword
    }

    if(this.validateCaptcha$){this.validateCaptcha$.unsubscribe();}
    this.validateCaptcha$= this.userService.validateCaptcha(this.CaptchaTokenValue, this.CaptchaTextValue, this.changePassword.value.captchaText)
    .subscribe((res)=>{
      if(res && res.status === 'true') {
        this.userService.changePassword(payloadForChange).subscribe((res) => {
          if (res.success) {
            this.loginErrorMessage = ''
            this.notificationService.success(res.message);
            this.changePasswordMessage = res.message;
            let loginPayload = {
              "emailId": this.userData.email,
              "password": this.changePassword.value.confirmPassword
            }
            this.userService.signIn(loginPayload).subscribe((data) => {
              if (data.status != 'false') {
                localStorage.clear();
                const langId = data.data.langId;
                langId ? localStorage.setItem('langId',langId) : localStorage.setItem('langId','1');
                const langCode = data.data.languagecode;
                langCode !== undefined ? localStorage.setItem('language',langCode) : null;

                this.roleSer.startRoleManagement();

                this.collectionData$ = this.collectionService.getCollection()?.subscribe((collectionData: any) => {
                  let collections = collectionData?.data;
                  sessionStorage.removeItem('aiToken');
                  if (collectionData.data && collectionData.data.length > 0) {
                    sessionStorage.defaultcollectionid = JSON.stringify(collections[0].collectionid);
                    sessionStorage.defaultcollectionuuid = JSON.stringify(collections[0].collectionuuId);
                    this.roleSer.getAccessDetails(RoleManagement.Items, true);
                  }

                  this.resetIdealLogoutFlag();
                },
                  (error: any) => {
                    this.isValid = false;
                    this.webErrorService.handleAPIErrors(error);
                  });
              } else {
                this.isValid = false;
                this.isDisplayError = false;
                this.loginErrorMessage = data.message;
                this.resendCaptcha();
              }
            },
            error => { this.loginErrorMessage = error.error.message; this.resendCaptcha();});
          }
        },
        error => { this.loginErrorMessage = error.error.message; this.resendCaptcha();});
      } else {
        this.resendCaptcha();
        this.isDisplayError = false;
        this.loginErrorMessage = res.message
      }
    });

  }

  resetIdealLogoutFlag(): void {
    this.idleService.showIdealLogoutMessage = false;
    localStorage.removeItem('Idle_logout');
  }

  cancel() {
    this.router.navigate(['/login']);
  }
}
